function apiConfig (self) {
  let port = window.location.port
  if (port !== '') {
    port = ':' + port
  }
  // TODO: Need to make basePath into a universal utility
  const basePath = window.location.hostname + port
  const csrfToken = () => {
    return undefined //self.$cookie.get('csrftoken')
  }
  const restToken = () => {
    return undefined // self.$cookie.get('resttoken')
  }
  const header = () => {
    return {
      'X-CSRFToken': csrfToken(),
      Authorization: restToken() ? 'Token ' + restToken() : '',
    }
  }
  const requestObj = () => {
    return {
      headers: header(),
    }
  }
  function buildPromise (rq, successFunc, failFunc) {
    return new Promise(function (resolve, reject) {
      rq.then(response => {
        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          if (successFunc !== undefined) {
            successFunc(response)
          }
          resolve(response)
        } else {
          console.error(
            'API Request - returned non 200 response',
            response
          )
          if (failFunc !== undefined) {
            failFunc(response)
          }
          resolve(response)
        }
      }).catch(err => {
        if (err.message && err.message.includes('413')) {
          console.warn('The file you tried to upload is too large.')
        }
        console.error('API Request - could not make http request: ', err)
        reject(err.response ? err.response.data : err)
      })
    })
  }
  return {
    context: self,
    csrfToken,
    restToken,
    header,
    requestObj,
    buildPromise,
    basePath,
  }
}

export default apiConfig
